export const FAQS = [
    {
        q: "What is Marma Chikitsa?",
        a: "Marma Chikitsa is a practice from the classical Ayurvedic tradition centred on marma — vital points of the body. Sessions use gentle, precise touch, often with warm herbal oils, and are always personalized to you.",
    },
    {
        q: "Is Marma Chikitsa safe?",
        a: "The practice is gentle and non-invasive. Before your first session we discuss your health background, and we ask you to tell us about any medical conditions, pregnancy, recent surgery or injury. When in doubt, please consult your physician first.",
    },
    {
        q: "Can Marma Chikitsa cure diseases?",
        a: "No. We do not claim that Marma Chikitsa or any complementary therapy cures, treats or prevents any disease. It is a wellness practice drawn from classical tradition and should complement — never replace — the care of a qualified medical practitioner. Please continue your prescribed treatments and consult your doctor about any health concern.",
    },
    {
        q: "What happens during a session?",
        a: "We begin with a short conversation about your concerns and comfort. The session itself involves gentle touch on selected points, often with warm oils, at a pace and pressure you are comfortable with — followed by a few minutes of rest and simple aftercare suggestions.",
    },
    {
        q: "How do I book a consultation?",
        a: "Simply call or WhatsApp us on 89781 33934. We will help you find a suitable time and answer any questions you have before your visit.",
    },
    {
        q: "Where is the clinic located?",
        a: "We are at H.No: 87-1299, Road No. 6A, Nagi Reddy Revenue Colony, near Vastralaya Mall, Kurnool, Andhra Pradesh – 518002. Use the Get Directions button on this page to navigate to us on Google Maps.",
    },
];
